import { Theme, css } from '@emotion/react';

const RAIL_HEIGHT = 2;
const MARK_HEIGHT = 13;
const THUMB_DIAMETER = 20;
const THUMB_BORDER = 2;
const THUMB_OFFSET_Y = (THUMB_DIAMETER - RAIL_HEIGHT) / 2;
const THUMB_OFFSET_X = THUMB_DIAMETER / 2;

const FOCUS_SHADOW_SEPARATION = 1;
const FOCUS_SHADOW_SIZE = 2;

const FOCUS_SHADOW_POSITION = -1 * (FOCUS_SHADOW_SEPARATION + FOCUS_SHADOW_SIZE);

export const base = ({ colors, interactiveStates, typography }: Theme) => css`
  &.MuiSlider-root {
    color: ${colors.borderDefault};
    padding: ${THUMB_OFFSET_Y}px 0;
  }

  & .MuiSlider-rail {
    height: ${RAIL_HEIGHT}px;
    opacity: 1;
  }

  & .MuiSlider-mark {
    height: ${MARK_HEIGHT}px;
    top: ${(THUMB_DIAMETER - MARK_HEIGHT) / 2}px;
  }

  & .MuiSlider-markLabel {
    color: ${colors.fgSubtle};
    ${typography.variant('caption')};
  }

  & .MuiSlider-markLabelActive {
    color: ${colors.fgDefault};
  }

  & .MuiSlider-track {
    color: ${colors.fgPrimaryBase};
    height: ${RAIL_HEIGHT}px;
  }

  & .MuiSlider-thumb {
    color: ${colors.fgPrimaryBase};
    width: ${THUMB_DIAMETER}px;
    height: ${THUMB_DIAMETER}px;
    margin-top: -${THUMB_OFFSET_Y}px;
    margin-left: -${THUMB_OFFSET_X}px;

    &::after {
      bottom: ${FOCUS_SHADOW_POSITION}px;
      box-shadow: 0 0 0 ${FOCUS_SHADOW_SIZE} transparent;
      content: '';
      left: ${FOCUS_SHADOW_POSITION}px;
      pointer-events: none;
      position: absolute;
      right: ${FOCUS_SHADOW_POSITION}px;
      top: ${FOCUS_SHADOW_POSITION}px;
    }

    ${interactiveStates.hover(css`
      color: ${colors.fgPrimaryDark};
    `)}

    ${interactiveStates.active(css`
      color: ${colors.fgPrimaryDark};
    `)}

    ${interactiveStates.focus(css`
      &::after {
        box-shadow: 0 0 0 ${FOCUS_SHADOW_SIZE}px ${colors.borderPrimaryBase};
      }
    `)}
  }

  & .MuiSlider-thumb + .MuiSlider-thumb {
    box-shadow: inset 0 0 0 ${THUMB_BORDER}px ${colors.borderPrimaryBase};
    color: ${colors.bgDefault};

    ${interactiveStates.hover(css`
      box-shadow: inset 0 0 0 ${THUMB_BORDER}px ${colors.borderPrimaryDark};
      color: ${colors.bgLighter};
    `)}

    ${interactiveStates.active(css`
      box-shadow: inset 0 0 0 ${THUMB_BORDER}px ${colors.borderPrimaryDark};
      color: ${colors.bgLight};
    `)}
  }
`;

export const fieldLabelContainer = css`
  align-items: baseline;
  display: flex;
  justify-content: space-between;
`;

export const fieldSliderContainer = ({ spacing }: Theme) => css`
  height: ${THUMB_DIAMETER}px;
  margin: ${spacing(1)}px 0 ${spacing(1)}px;
`;

export const fieldBoundLabelContainer = css`
  display: flex;
  justify-content: space-between;
`;
